<template>
    <b-container>
        <h4 class="mt-4 p-2 text-center text-primary text-uppercase">Mis Datos Personales</h4>
        <div class="text-center">
            <div class="figure-profile shadow my-4">
                <figure>
                    <img :src="img ? img : '/img/user-default.png'"
                         :alt="(user.name + ' ' + user.lname).replace(',', '')"
                         :title="(user.name + ' ' + user.lname).replace(',', '')">
                </figure>
                <b-button variant="default" class="text-white floating-btn" v-if="user.status === 201">
                    <i class="material-icons">camera_alt</i>
                    <b-form-file
                        name="photo"
                        v-model="form.photo"
                        v-validate="!img ? 'required:true|image' : 'image'"
                        :data-vv-as="(labels.photo).toLowerCase()"
                        aria-describedby="photo-live-feedback"
                        :state="(form.photo ? Boolean(form.photo) : form.photo) || validateState('photo')"
                        accept="image/*"
                        class="float-file"
                        :disabled="loading || (user.status !== 201)"/>
                </b-button>
                <b-form-invalid-feedback
                    id="photo-live-feedback"
                    :state="validateState('photo')"
                >{{ veeErrors.first('photo') }}</b-form-invalid-feedback>
            </div>
        </div>

        <b-form id="formInfo" @submit.stop.prevent="submit">
            <h6 class="subtitle text-center">Información Básica</h6>
            <b-row align-h="center">
                <b-col cols="12" md="10" align-self="start">
                    <b-form-group :label="labels.name+':'" label-class="text-center">
                        <b-form-input
                            name="name"
                            type="text"
                            v-model="form.name"
                            v-validate="'required:true|alpha_spaces|min:3|max:20'"
                            :state="validateState('name')"
                            :data-vv-as="(labels.name).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="name-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="name-live-feedback">{{ veeErrors.first('name') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.lname+':'" label-class="text-center">
                        <b-form-input
                            name="lname"
                            type="text"
                            v-model="form.lname"
                            v-validate="'required:true|alpha_spaces|min:3|max:20'"
                            :state="validateState('lname')"
                            :data-vv-as="(labels.lname).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="lname-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="lname-live-feedback">{{ veeErrors.first('lname') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.mname+':'" label-class="text-center">
                        <b-form-input
                            name="mname"
                            type="text"
                            v-model="form.mname"
                            v-validate="'alpha_spaces|max:19'"
                            :state="validateState('mname')"
                            :data-vv-as="(labels.mname).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="mname-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="mname-live-feedback">{{ veeErrors.first('mname') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.email+':'" label-class="text-center">
                        <b-form-input
                            name="email"
                            type="email"
                            v-model="form.email"
                            v-validate="'required:true|email'"
                            :state="validateState('email')"
                            :data-vv-as="(labels.email).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="email-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="email-live-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.mobile+':'" label-class="text-center">
                        <b-form-input
                            name="mobile"
                            type="text"
                            inputmode="numeric"
                            v-model="form.mobile"
                            v-validate="'required:true|numeric'"
                            :state="validateState('mobile')"
                            :data-vv-as="(labels.mobile).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="mobile-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="mobile-live-feedback">{{ veeErrors.first('mobile') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.birthday+':'" label-class="text-center">
                        <b-form-datepicker
                            name="birthday"
                            v-model="form.birthday"
                            v-bind="labels['es'] || {}"
                            v-validate="'required:true|date_format:yyyy-MM-dd'"
                            :state="validateState('birthday')"
                            :data-vv-as="(labels.birthday).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="birthday-live-feedback"
                            locale="es"
                            :min="minDate"
                            :max="maxDate"
                            hide-header
                            no-flip
                            class="text-left"
                        ></b-form-datepicker>
                        <b-form-invalid-feedback id="birthday-live-feedback">{{ veeErrors.first('birthday') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.profession+':'" label-class="text-center">
                        <b-form-select
                            name="profession"
                            :options="professions"
                            :value="form.profession"
                            v-model="form.profession"
                            v-validate="'required:true'"
                            :state="validateState('profession')"
                            :data-vv-as="(labels.profession).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="profession-live-feedback"
                            class="form-control"
                            value-field="name"
                            text-field="name"
                        ></b-form-select>
                        <b-form-invalid-feedback id="profession-live-feedback">{{ veeErrors.first('profession') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="10" align-self="start">
                    <b-form-group :label="labels.pep+':'" label-class="text-center">
                        <b-form-select
                            name="pep"
                            :options="yes_no"
                            :value="form.pep"
                            v-model="form.pep"
                            v-validate="'required:true'"
                            :state="validateState('pep')"
                            :data-vv-as="(labels.pep).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="pep-live-feedback"
                            class="form-control"
                            value-field="code"
                            text-field="text"
                        ></b-form-select>
                        <b-form-invalid-feedback id="pep-live-feedback">{{ veeErrors.first('pep') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="12" md="10" align-self="center">
                    <hr>
                </b-col>
            </b-row>
            <h6 class="subtitle text-center mt-0">Identificación Personal</h6>
            <b-row align-h="center">
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.td+':'" label-class="text-center">
                        <b-form-select
                            name="td"
                            :options="td"
                            :value="form.td"
                            v-model="form.td"
                            v-validate="'required:true'"
                            :state="validateState('td')"
                            :data-vv-as="(labels.td).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="td-live-feedback"
                            class="form-control"
                            value-field="code"
                            text-field="name"
                        ></b-form-select>
                        <b-form-invalid-feedback id="td-live-feedback">{{ veeErrors.first('td') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start" v-if="form.td === 'RUT'">
                    <b-form-group :label="labels.rut+':'" label-class="text-center">
                        <b-form-input
                            name="rut"
                            type="text"
                            v-model="form.rut"
                            v-validate="'required:true'"
                            :state="validateState('rut')"
                            :data-vv-as="(labels.rut).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="rut-live-feedback"
                            v-mask="mask"
                        ></b-form-input>
                        <b-form-invalid-feedback id="rut-live-feedback">{{ veeErrors.first('rut') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start" v-else>
                    <b-form-group :label="labels.nd+':'" label-class="text-center">
                        <b-form-input
                            name="nd"
                            :type="form.td === 'PS' ? 'text' : 'number'"
                            :inputmode="form.td === 'PS' ? 'text' : 'numeric'"
                            v-model="form.nd"
                            v-validate="'required:true'"
                            :state="validateState('nd')"
                            :data-vv-as="(labels.nd).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="nd-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="nd-live-feedback">{{ veeErrors.first('nd') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.issuedBy+':'" label-class="text-center">
                        <b-form-select
                            name="issuedBy"
                            :options="countries_list"
                            :value="form.issuedBy"
                            v-model="form.issuedBy"
                            v-validate="'required:true'"
                            :state="validateState('issuedBy')"
                            :data-vv-as="(labels.issuedBy).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="issuedBy-live-feedback"
                            class="form-control"
                            value-field="iso2"
                            text-field="name"
                        ></b-form-select>
                        <b-form-invalid-feedback id="issuedBy-live-feedback">{{ veeErrors.first('issuedBy') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.expiration+':'" label-class="text-center">
                        <b-form-datepicker
                            name="expiration"
                            v-model="form.expiration"
                            v-bind="labels['es'] || {}"
                            v-validate="'required:true|date_format:yyyy-MM-dd'"
                            :state="validateState('expiration')"
                            :data-vv-as="(labels.expiration).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="expiration-live-feedback"
                            locale="es"
                            :min="minDateExp"
                            hide-header
                            no-flip
                            class="text-left"
                        ></b-form-datepicker>
                        <b-form-invalid-feedback id="expiration-live-feedback">{{ veeErrors.first('expiration') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="12" md="10" align-self="center">
                    <hr>
                </b-col>
            </b-row>
            <h6 class="subtitle text-center mt-0">Ubicación Actual</h6>
            <b-row align-h="center">
                <b-col cols="12" md="10" align-self="start">
                    <b-form-group :label="labels.address+':'" label-class="text-center">
                        <b-form-input
                            name="address"
                            type="text"
                            v-model="form.address"
                            v-validate="'required:true|min:3|max:70'"
                            :state="validateState('address')"
                            :data-vv-as="(labels.address).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="address-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="address-live-feedback">{{ veeErrors.first('address') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.district+':'" label-class="text-center">
                        <b-form-input
                            name="district"
                            type="text"
                            v-model="form.district"
                            v-validate="'required:true|min:3|max:35'"
                            :state="validateState('district')"
                            :data-vv-as="(labels.district).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="district-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="district-live-feedback">{{ veeErrors.first('district') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.zipcode+':'" label-class="text-center">
                        <b-form-input
                            name="zipcode"
                            v-model="form.zipcode"
                            type="text"
                            class="text-center"
                            v-validate="'required:true|min:4|max:8'"
                            :state="validateState('zipcode')"
                            :data-vv-as="(labels.zipcode).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="zipcode-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="zipcode-live-feedback">{{ veeErrors.first('zipcode') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.city+':'" label-class="text-center">
                        <b-form-input
                            name="city"
                            type="text"
                            v-model="form.city"
                            v-validate="'required:true|alpha_spaces|min:3|max:35'"
                            :state="validateState('city')"
                            :data-vv-as="(labels.city).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="city-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="city-live-feedback">{{ veeErrors.first('city') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.state+':'" label-class="text-center">
                        <b-form-input
                            name="state"
                            type="text"
                            v-model="form.state"
                            v-validate="'required:true|alpha_spaces|min:3|max:35'"
                            :state="validateState('state')"
                            :data-vv-as="(labels.state).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="state-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="state-live-feedback">{{ veeErrors.first('state') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="12" md="10" align-self="center">
                    <hr>
                </b-col>
            </b-row>
            <h6 class="subtitle text-center mt-0">Documento</h6>
            <b-row align-h="center">
                <b-col cols="12" md="5" align-self="start">
                    <div class="text-center">
                        <div class="document-profile shadow my-4">
                            <figure>
                                <img :src="front ? front : '/img/doc_front.png'" alt="Documento Frontal" title="Documento Frontal">
                            </figure>
                            <b-button variant="default" class="text-white floating-btn" v-if="user.status === 201">
                                <i class="material-icons">camera_alt</i>
                                <b-form-file
                                    name="front"
                                    v-model="form.front"
                                    v-validate="!front ? 'required:true|image' : 'image'"
                                    :data-vv-as="(labels.front).toLowerCase()"
                                    aria-describedby="front-live-feedback"
                                    :state="(form.front ? Boolean(form.front) : form.front) || validateState('front')"
                                    accept="image/*"
                                    class="float-file"
                                    :disabled="loading || (user.status !== 201)"/>
                            </b-button>
                            <b-form-invalid-feedback
                                id="front-live-feedback"
                                :state="validateState('front')"
                            >{{ veeErrors.first('front') }}</b-form-invalid-feedback>
                        </div>
                    </div>
                </b-col>
                <b-col cols="12" md="5" align-self="start">
                    <div class="text-center">
                        <div class="document-profile shadow my-4">
                            <figure>
                                <img :src="post ? post : '/img/doc_post.png'" alt="Documento Posterior" title="Documento Posterior">
                            </figure>
                            <b-button variant="default" class="text-white floating-btn" v-if="user.status === 201">
                                <i class="material-icons">camera_alt</i>
                                <b-form-file
                                    name="post"
                                    v-model="form.post"
                                    v-validate="!post ? 'required:true|image' : 'image'"
                                    :data-vv-as="(labels.post).toLowerCase()"
                                    aria-describedby="post-live-feedback"
                                    :state="(form.post ? Boolean(form.post) : form.post) || validateState('post')"
                                    accept="image/*"
                                    class="float-file"
                                    :disabled="loading || (user.status !== 201)"/>
                            </b-button>
                            <b-form-invalid-feedback
                                id="post-live-feedback"
                                :state="validateState('post')"
                            >{{ veeErrors.first('post') }}</b-form-invalid-feedback>
                        </div>
                    </div>
                </b-col>
            </b-row>
            <b-row align-h="center" v-if="user.status === 201">
                <b-col cols="12" md="10" align-self="center">
                    <hr>
                </b-col>
            </b-row>
            <h6 class="subtitle text-center mt-0" v-if="user.status === 201">Seguridad</h6>
            <b-row align-h="center" v-if="user.status === 201">
                <b-col cols="12" md="5" align-self="start">
                    <b-form-group :label="labels.pass+':'" label-class="text-center">
                        <b-form-input
                            name="pass"
                            type="password"
                            v-model="form.pass"
                            class="text-center"
                            v-validate="'required:true'"
                            :state="validateState('pass')"
                            :data-vv-as="(labels.pass).toLowerCase()"
                            :disabled="loading || (user.status !== 201)"
                            aria-describedby="pass-live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="pass-live-feedback">{{ veeErrors.first('pass') }}</b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row align-h="center">
                <b-col cols="12" md="10" class="my-5 text-center">
                    <b-button :type="user.status === 201 ? 'submit' : 'button'" :variant="labels.btnColor" size="lg" pill class="shadow px-5"
                              form="formInfo" :disabled="loading">
                        <b-spinner small type="grow" v-if="loading"></b-spinner>
                        <b-icon :icon="labels.btnIcon" aria-hidden="true" v-else></b-icon>
                        &nbsp;&nbsp;<span>{{ loading ? labels.load : labels.btnText }}</span>
                    </b-button>
                </b-col>
            </b-row>
        </b-form>
    </b-container>
</template>

<script>
import axios from "axios";
import Compressor from 'compressorjs';

export default {
    name: "Info",
    props: [ 'user' ],
    data: () => ({
        labels: {
            name: 'Nombres',
            lname: 'Primer Apellido',
            mname: 'Segundo Apellido',
            email: 'Correo Electrónico',
            mobile: 'Teléfono',
            birthday: 'Fecha de Nacimiento',
            profession: 'Profesión',
            pep: '¿Eres Persona Expuesta Políticamente?',

            td: 'Tipo de Documento',
            nd: 'Número de Documento',
            rut: 'RUT',
            issuedBy: 'País de emisión',
            expiration: 'Fecha de Vencimiento',
            noExp: 'Sin Fecha de Vencimiento',

            address: 'Dirección',
            district: 'Comuna/Barrio',
            zipcode: 'Código Postal',
            city: 'Ciudad',
            state: 'Región/Departamento',

            photo: 'Foto',
            front: 'Frontal',
            post: 'Posterior',

            pass: 'Contraseña',

            load: 'Actualizando...',

            btnIcon: 'patch-check-fill',
            btnText: 'Actualizar',
            btnColor: 'default',

            es: {
                labelPrevDecade: 'Década Anterior',
                labelPrevYear: 'Año Anterior',
                labelPrevMonth: 'Mes Anterior',
                labelCurrentMonth: 'Mes Actual',
                labelNextMonth: 'Próximo Mes',
                labelNextYear: 'Próximo Año',
                labelNextDecade: 'Próxima Década',
                labelToday: 'Hoy',
                labelSelected: 'Fecha Seleccionada',
                labelNoDateSelected: 'Sin fecha seleccionada',
                labelCalendar: 'Calendario',
                labelNav: 'Navegar por el calendario',
                labelHelp: 'Use las teclas de flecha para navegar por el calendario'
            }
        },
        form: {
            name: '',
            lname: '',
            mname: '',
            email: '',
            mobile: '',
            birthday: undefined,
            profession: '',
            pep: 0,

            td: '',
            nd: '',
            rut: null,
            issuedBy: '',
            expiration: undefined,

            address: '',
            district: '',
            zipcode: '',
            city: '',
            state: '',
            country: 'CL',

            photo: null,
            front: null,
            post: null,

            pass: ''
        },
        compress: {
            photo: null,
            front: null,
            post: null
        },
        minDate: undefined,
        maxDate: undefined,
        td: [
            { code: 'RUT', name: 'RUT' },
            { code: 'DNI', name: 'Documento Nacional de Identidad' },
            { code: 'CI', name: 'Cédula de Identidad' },
            { code: 'CE', name: 'Cédula de Extranjeria' },
            { code: 'PS', name: 'Pasaporte' }
        ],
        professions: [
            { name: 'Ingeniero/a' },
            { name: 'Estudiante' },
            { name: 'Comerciante' },
            { name: 'Empresario/a' },
            { name: 'Abogado/a' },
            { name: 'Administrador/a' },
            { name: 'Médico/a' },
            { name: 'Arquitecto/a' },
            { name: 'Economista' },
            { name: 'Profesor/a' },
            { name: 'Programador/a' },
            { name: 'Amo/a de Casa' },
            { name: 'Artísta ó Artesano/a' },
            { name: 'Rentista de Capital' },
            { name: 'Policía ó Militar' },
            { name: 'Agricultor/a, Ganadero/a ó Pescador/a' },
            { name: 'Técnico/a' },
            { name: 'Otra' }
        ],
        yes_no: [
            { code: 0, text: 'No' },
            { code: 1, text: 'Si' }
        ],
        countries_list: [],
        minDateExp: undefined,
        loading: false,
        img: undefined,
        front: undefined,
        post: undefined,
        mask: '##.###.###-N'
    }),
    mounted() {
        this.$emit('loader');
        this.$emit('section', 'infopage');
        this.$emit('success');
        this.getData();
        this.getDate();
        this.getStatus();
    },
    watch: {
        'user.status'() {
            this.getStatus();
        },
        'form.td'() {
            if (this.form.td === 'RUT') {
                this.form.nd = null;
            } else {
                this.form.rut = null;
            }
        },
        'form.nd'() {
            if (this.form.nd) {
                this.form.nd = (this.form.nd).toUpperCase();
            }
        },
        'form.rut'() {
            if (this.form.rut) {
                this.form.rut = (this.form.rut).toUpperCase();
                if (this.form.td === 'RUT') {
                    this.form.nd = this.form.rut;
                }
            }
        },
        'form.photo'() {
            if (this.form.photo) {
                this.getImg(1);
                this.updateImg(1, this.form.photo, 'de perfil');
            }
        },
        'form.front'() {
            if (this.form.front) {
                this.getImg(2);
                this.updateImg(2, this.form.front, 'principal del documento');
            }
        },
        'form.post'() {
            if (this.form.post) {
                this.getImg(3);
                this.updateImg(3, this.form.post, 'posterior del documento');
            }
        }
    },
    methods: {
        getData() {
            this.loading = true;
            axios.get('/api/customer/info').then((res) => {
                if (res.data.status === 'success') {
                    if (res.data.user) {
                        let lname = (res.data.user.lname).split(', ', 2);

                        this.form.name = res.data.user.name;
                        this.form.lname = lname[0];
                        this.form.mname = lname[1] ? lname[1] : '';
                        this.form.email = res.data.user.email;
                        this.form.mobile = res.data.user.mobile;
                        this.form.birthday = res.data.user.birthday;
                        this.form.profession = res.data.user.profession;
                        this.form.pep = res.data.user.pep;
                        this.form.td = res.data.user.td;
                        this.form.nd = res.data.user.nd;
                        this.form.rut = res.data.user.rut;
                        this.form.issuedBy = res.data.user.issuedBy;
                        this.form.expiration = res.data.user.expiration;
                        this.form.address = res.data.user.address;
                        this.form.district = res.data.user.district;
                        this.form.zipcode = res.data.user.zipcode;
                        this.form.city = res.data.user.city;
                        this.form.state = res.data.user.state;
                        this.form.country = res.data.user.country;
                        this.form.photo = null;
                        this.form.front = null;
                        this.form.post = null;
                        if (res.data.user.photo) {
                            this.img = '/' + res.data.user.photo;
                        } else {
                            this.img = null;
                        }
                        if (res.data.user.front) {
                            this.front = '/' + res.data.user.front;
                        } else {
                            this.front = null;
                        }
                        if (res.data.user.post) {
                            this.post = '/' + res.data.user.post;
                        } else {
                            this.post = null;
                        }
                    } else {
                        let lname = (this.user.lname).split(', ', 2);
                        this.form.name = this.user.name;
                        this.form.lname = lname[0];
                        this.form.mname = lname[1] ? lname[1] : '';
                        this.form.email = this.user.email;
                        this.form.mobile = this.user.phone;
                        if (this.user.photo) {
                            this.img = '/' + this.user.photo;
                        }
                        if (this.user.front) {
                            this.front = '/' + this.user.front;
                        }
                        if (this.user.post) {
                            this.post = '/' + this.user.post;
                        }
                    }
                    this.countries_list = res.data.countries;
                }
            }).catch(err => {
                this.$root.$bvToast.toast(err.response.data.errors, {
                    title: 'Notificación',
                    headerClass: 'd-none',
                    variant: 'error',
                    toaster: 'b-toaster-top-right',
                    autoHideDelay: 5000,
                    solid: true,
                    appendToast: true
                });
            }).then(() => {
                this.loading = false;
            });
        },
        getDate() {
            const now = new Date()
            const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
            // 100 años menos
            const minDate = new Date(today)
            minDate.setFullYear(minDate.getFullYear() - 100)
            // 18 años menos
            const maxDate = new Date(today)
            maxDate.setFullYear(maxDate.getFullYear() - 18)

            this.minDate = minDate;
            this.maxDate = maxDate;
            this.minDateExp = today;
        },
        getStatus() {
            this.labels.btnColor = 'default';
            this.labels.btnIcon = 'patch-check-fill';
            this.labels.btnText = 'Actualizar';
            if (this.user.status === 203) {
                this.labels.btnColor = 'success';
                this.labels.btnText = 'Aprobado';
            } else if (this.user.status === 202) {
                this.labels.btnColor = 'warning';
                this.labels.btnIcon = 'patch-exclamation-fill';
                this.labels.btnText = 'En Revisión';
            }
        },
        getImg(v) {
            let input = null;
            if (v === 1) {
                input = this.form.photo;
            } else if (v === 2) {
                input = this.form.front;
            } else if (v === 3) {
                input = this.form.post;
            }

            if (input) {
                const reader = new FileReader;
                reader.onload = e => {
                    if (v === 1) {
                        this.img = e.target.result;
                    } else if (v === 2) {
                        this.front = e.target.result;
                    } else if (v === 3) {
                        this.post = e.target.result;
                    }
                };
                reader.readAsDataURL(input);
            }
        },
        validateState(ref) {
            if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
                return !this.veeErrors.has(ref);
            }
            return null;
        },
        resetValidationState() {
            this.isValid = undefined
        },
        updateImg(v, img, title) {
            new Compressor(img, {
                quality: 0.6,
                maxWidth: 2048,
                success(result) {
                    let formData = new FormData();

                    formData.append('name', title);
                    if (v === 1) {
                        formData.append('photo', result, result.name);
                    } else if (v === 2) {
                        formData.append('front', result, result.name);
                    } else if (v === 3) {
                        formData.append('post', result, result.name);
                    }

                    axios.post('/api/customer/img/update', formData, {
                        headers: {'Content-Type': 'multipart/form-data'}
                    }).then(() => {
                        console.log('imagen cargada correctamente!');
                    });
                },
                error(err) {
                    console.log(err.message);
                }
            });
        },
        submit() {
            if (this.user.status === 201) {
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        this.$root.$bvToast.toast('Por favor, revise el formulario e intente nuevamente', {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                        return;
                    }
                    this.loading = true;
                    let formData = new FormData();

                    formData.append('name', this.form.name);
                    formData.append('lname', this.form.lname);
                    formData.append('mname', this.form.mname);
                    formData.append('email', this.form.email);
                    formData.append('mobile', this.form.mobile);
                    formData.append('birthday', this.form.birthday);
                    formData.append('profession', this.form.profession);
                    formData.append('pep', this.form.pep);
                    formData.append('td', this.form.td);
                    formData.append('nd', this.form.nd);
                    formData.append('rut', this.form.rut);
                    formData.append('issuedBy', this.form.issuedBy);
                    formData.append('expiration', this.form.expiration);
                    formData.append('address', this.form.address);
                    formData.append('district', this.form.district);
                    formData.append('zipcode', this.form.zipcode);
                    formData.append('city', this.form.city);
                    formData.append('state', this.form.state);
                    formData.append('country', this.form.country);
                    formData.append('pass', this.form.pass);

                    axios.post('/api/customer/info/update', formData, {
                        headers: {'Content-Type': 'multipart/form-data'}
                    }).then(res => {
                        this.$root.$bvToast.toast(res.data.msg, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: res.data.status,
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                        this.form.pass = '';
                        this.$validator.reset();
                        this.$store.dispatch('setUser', res.data);
                        this.$emit('success');
                    }).catch(err => {
                        this.$root.$bvToast.toast(err.response.data.errors, {
                            title: 'Notificación',
                            headerClass: 'd-none',
                            variant: 'error',
                            toaster: 'b-toaster-top-right',
                            autoHideDelay: 5000,
                            solid: true,
                            appendToast: true
                        });
                    }).then(() => {
                        this.loading = false;
                    });
                });
            }
        }
    }
}
</script>

<style scoped>

</style>
